import type React from 'react';
import classNames from 'classnames';

import Icons from 'assets/icons';

import {
  COPY_CONFIRMATION_LABEL,
  INLINE_CONFIRMATION_FADE_MS,
} from '../../ai-assistant.constants';

import type { ConfirmationPhase } from '../../hooks/use-timed-confirmation';

export interface CopiedBadgeProps {
  phase: Exclude<ConfirmationPhase, 'idle'>;
}

/** Visual-only confirmation; screen readers use `CopyAnnouncer`. */
const CopiedBadge = ({ phase }: CopiedBadgeProps): React.JSX.Element => (
  <div
    aria-hidden="true"
    className={classNames(
      'flex items-center gap-1.5 rounded-md bg-white px-2 py-1 transition-opacity',
      phase === 'leaving' ? 'opacity-0' : 'animate-fade-in opacity-100'
    )}
    style={{ transitionDuration: `${INLINE_CONFIRMATION_FADE_MS}ms` }}
    data-testid="message-copy-confirmation"
  >
    <Icons.Check aria-hidden="true" className="size-4 shrink-0 text-gray-500" />
    <span className="text-sm font-semibold leading-5 text-gray-500">
      {COPY_CONFIRMATION_LABEL}
    </span>
  </div>
);

export default CopiedBadge;
